import { genMessage } from '../helper';
// import elementPlus from 'element-plus/dist/locale/ja.mjs';
// 修改文件
const modules = import.meta.glob('./ja/*.ts', { eager: true });
export default {
	message: {
		...genMessage(modules, 'ja'),
	},
	// dateLocale: elementPlus,
	dateLocaleName: 'Ja',
};
